export const IMAGES = 1024 * 1024 * 3
export const EMAIL = 'info@sapienstone.com'
export const NO_REPLY_EMAIL = 'no-reply@sapienstone.com'
export const BUSINESS = {
	name: 'Sapienstone',
	address: 'Via Canaletto, 24 - 41053 Maranello (MO) - Italy',
	phone: '',
	email: EMAIL,
}
export const SOCIAL = {
	instagram: 'https://www.instagram.com/sapienstone/',
	facebook: 'https://www.facebook.com/sapienstone/',
	pinterest: 'https://www.pinterest.com/sapienstone/',
	twitter: 'https://twitter.com/sapienstone',
}
export const PRODUCTION_URL = 'https://www.sapienstone.com'
export const BASE_URL =
	process.env.NODE_ENV === 'production'
		? PRODUCTION_URL
		: 'http://localhost:3005'
